module.exports = __webpack_public_path__ + "static/media/moi.a9718093.jpeg";